import { GetterTree } from 'vuex';
import { ProductState, RootState } from '@/store/types';
import { Product } from '@/models/product';

const getters: GetterTree<ProductState, RootState> = {
  getProducts: (state: ProductState): Product[] => {
    return state.products;
  },
  getSearch: (state: ProductState): string => {
    return state.search;
  },
};

export default getters;
